import { render, staticRenderFns } from "./TotalSummaryDetail.vue?vue&type=template&id=ad2221a0&scoped=true"
import script from "./TotalSummaryDetail.vue?vue&type=script&lang=js"
export * from "./TotalSummaryDetail.vue?vue&type=script&lang=js"
import style0 from "./TotalSummaryDetail.vue?vue&type=style&index=0&id=ad2221a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2221a0",
  null
  
)

export default component.exports